// Fase 3: construye los registros de guardado masivo a partir de las filas
// ya validadas (fase 2) y los escribe en Firebase uno por uno (no en un solo
// update() atómico), con una pausa entre cada registro para darle tiempo al
// sistema de asignación de folios a procesar cada inscripción antes de que
// llegue la siguiente.

import * as fb from "../../../../../firebase/firebasejs";
import firebase from "firebase";
import { fechahora } from "../../../../../services/utils";

// Pausa entre cada registro guardado, en milisegundos.
const DELAY_ENTRE_REGISTROS_MS = 1200;

function esperar(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

// Construye, para cada participante válido, el objeto final que se
// guardaría en eventosCompletos/{evento}/inscritos/listadoInscritos/{key},
// agregando los mismos campos de auditoría/pago que agrega
// registryParticipantDataFunc para un registro de punto de venta
// (tipoRegistro 2: pago ya cobrado por otro medio, como corresponde a datos
// importados de un proceso externo).
export function construirLoteDeGuardado(eventoIndex, participantesValidos, userID) {
  const route = `${fb.EventosCompletos}${eventoIndex}/${fb.inscritos}${fb.listadoInscritos}`;

  const registros = participantesValidos.map(({ participante }) => {
    const inscritoKey = fb.db.ref().child(route).push().key;

    const atleteData = {
      ...participante,
      tipoRegistro: 2,
      statusPago: {
        status: "ok",
        formaInscripcion: "Importación masiva",
        formaPago: "efectivo",
        fechaPago: fechahora(),
        serverTime: firebase.database.ServerValue.TIMESTAMP,
        idOperacion: 0,
      },
      usuarioRegistra: userID || "No registrado",
      fechaRegistro: fechahora(),
      serverTime: firebase.database.ServerValue.TIMESTAMP,
    };

    return {
      ruta: `${route}${inscritoKey}`,
      inscritoKey,
      nombres: participante.nombres,
      atleteData,
    };
  });

  return { route, registros };
}

// Guarda en Firebase, uno por uno y con una pausa entre cada registro
// (DELAY_ENTRE_REGISTROS_MS) para no saturar la asignación de folios.
// onProgress(actual, total, nombres) se llama después de guardar cada
// registro, útil para mostrar avance en la interfaz.
export async function guardarLoteEnFirebase(registros, onProgress) {
  const guardados = [];

  for (let i = 0; i < registros.length; i++) {
    const { ruta, inscritoKey, nombres, atleteData } = registros[i];
    await fb.db.ref(ruta).set(atleteData);
    guardados.push(inscritoKey);

    if (onProgress) onProgress(i + 1, registros.length, nombres);

    if (i < registros.length - 1) {
      await esperar(DELAY_ENTRE_REGISTROS_MS);
    }
  }

  return { guardado: true, total: guardados.length };
}
